export const CUSTOM_CART_ACTIONS = {
  APPLY_POINTS: "CustomApplyPoints",
  REMOVE_POINTS: "CustomRemovePoints",
  STORE_PURCHASER_DATA: "CustomStorePurchaserData",
  CLEAR: "CustomClear",
} as const
